// bannerSlides.jsx
// Each slide defines its own render() function — no conditionals needed in Banner.jsx
import React, { useState } from 'react';
import aiBanner from "./img/Banner/Ai2.png";
import servicenowpartner from './img/icons/servicenow.png';
import servicenow from './img/icons/ServiceNowlogo.png';
import servicenowmain from "./img/servicenow-main.png";
import ElevenLabs from "./img/Banner/Eleven-Labs.png";
import VB from "./img/icons/VB.png"
import ustpn from "./img/icons/ustpn.jpeg"
import tiaralogo from "./img/logoOld.png"
import banner1 from "./img/whats/banner1.jpg.jpeg";
import banner2 from "./img/whats/banner2.jpg.jpeg";
import banner3 from "./img/whats/bannerimg2.png";
import banner4 from "./img/whats/bannerimg7.jpg";
import banner5 from "./img/whats/bannerimg8.jpg";
import banner6 from "./img/whats/bannerimg6.jpg";
import hiringImage from "./img/hiring.png";
import drupalLogo from "./img/whats/Drupal-logo.png";
import acquiaLogo from "./img/whats/acquia.svg";
import snconfirmation from "./img/flyer.jpg";
import offeringsImage from "./img/offeringimg.png";
import raja from "./img/Banner/raja.jpeg";
import ReactDOM from 'react-dom';
import {
  sliderItems,
  salesCRMIcons,
  erpIcons,
  DEngIcons,
  aiIcons,
  cloudIcons,
  productsIcons
} from "./data/banner";
import eventImage from "./img/Banner/event-t3.jpeg";
const FullViewFlyer = ({ flyerImage }) => {
  const [isOpen, setIsOpen] = useState(false);

  const ModalPortal = () => {
    return ReactDOM.createPortal(
      <div className="system-wide-overlay" onClick={() => setIsOpen(false)}>
        <div className="system-wide-content" onClick={(e) => e.stopPropagation()}>
          <button className="close-system-view" onClick={() => setIsOpen(false)}>&times;</button>
          <img src={flyerImage} alt="Full View" className="full-browser-img" />
          <a href={flyerImage} download="Tiara_Flyer_HD.jpg" className="system-download-btn">
            <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" strokeWidth="2" fill="none" style={{ marginRight: '10px' }}>
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><polyline points="7 10 12 15 17 10" /><line x1="12" y1="15" x2="12" y2="3" />
            </svg>
            View & Download
          </a>
        </div>
      </div>,
      document.body
    );
  };

  return (
    <div className='row align-center' style={{ justifyContent: "center" }}>
      <div className="">


        {/* BUTTON WITH ICON */}
        <button onClick={() => setIsOpen(true)}>

          <span className='text-nowrap downloadbtn'>Corporate Summary</span>
        </button>

        {isOpen && <ModalPortal />}
      </div></div>
  );
};
export const bannerSlides = sliderItems.map((item) => {



  let renderContent;



  switch (item.menuName) {
    // case 'WhatIsNew':
    //   renderContent = () => (
    //     <>
    //       <div className="img-content">
    //         <div className="content-img">
    //           <img
    //             className="whatnew-img"
    //             src={item.src1}
    //             alt={`ustpnFlyer`}
    //           />
    //         </div>
    //         <div className="content-img">
    //           <img
    //             className="whatnew-img"
    //             src={item.src}
    //             alt={`What's New`}
    //           />
    //         </div>
    //       </div>
    //     </>
    //   );
    //   break;

//     case 'WhatIsNew':
    
// renderContent = () => (
//     <>
//       <div className="whatsnew-header">
//         <h3 className="whatsheadings">
//           What's New
//         </h3>

//         <p>
//           New Services &amp; Training
//         </p>
//       </div>

//       <div className="whatisnew-container">

//         {/* =====================================
//             DRUPAL WEBSITE DEVELOPMENT
//             ===================================== */}

//         <div className="whatsnew-service-card drupal-service-card">

//           <div className="whatsnew-card-top">

//             <div className="whatsnew-logo-box">
//               <img
//                 src={drupalLogo}
//                 alt="Drupal"
//                 className="whatsnew-drupal-logo"
//               />
//             </div>

//             <span className="whatsnew-label">
//               WEBSITE DEVELOPMENT
//             </span>

//           </div>


//           <h3 className="whatsnew-service-title">
//             Drupal CMS Website Development
//           </h3>


//           <p className="whatsnew-service-description">
//             We develop modern, scalable and user-friendly
//             websites using Drupal CMS.
//           </p>


//           <div className="whatsnew-partner">

//             <span>Our Technology Partner</span>

//             <img
//               src={acquiaLogo}
//               alt="Acquia Partner"
//               className="whatsnew-acquia-logo"
//             />

//           </div>


//           <a
//             href="/drupal"
//             className="whatsnew-outline-btn"
//           >
//             Explore Drupal Solutions
//             <span>→</span>
//           </a>

//         </div>


//         {/* =====================================
//             SERVICENOW TRAINING
//             ===================================== */}

//         <div className="whatsnew-service-card servicenow-service-card">

//           <div className="whatsnew-card-top">

//             <div className="whatsnew-logo-box servicenow-logo-box">
//               <img
//                 src={servicenow}
//                 alt="ServiceNow"
//                 className="whatsnew-servicenow-logo"
//               />
//             </div>

//             <span className="whatsnew-label training-label">
//               TRAINING
//             </span>

//           </div>


//           <h3 className="whatsnew-service-title">
//             ServiceNow Training
//           </h3>


//           <p className="whatsnew-service-description">
//             Build practical ServiceNow skills with
//             training designed for today's technology professionals.
//           </p>


//           <div className="training-points">

//             <span>
//               <b>✓</b> Practical Learning
//             </span>

//             <span>
//               <b>✓</b> Online &amp; Classroom
//             </span>

//           </div>


//           <a
//             href="/sntraining"
//             className="whatsnew-training-btn"
//           >
//             Explore ServiceNow Training
//             <span>→</span>
//           </a>

//         </div>

//       </div>
//     </>
//   );


//   break;
      
// case 'WhatIsNew':
//   renderContent = () => (
//     <>
//       <div className="whats-new-section">

//         {/* LEFT CONTENT */}
//         <div className="whats-new-left">

//           <h3 className="whats-new-heading">
//             What's New
//           </h3>

//           {/* ServiceNow Training */}
//           <a
//             href="/snconfirmation"
//             className="whats-new-feature"
//           >
//             <div className="feature-icon">
//               <img
//                 src={servicenowpartner}
//                 alt="ServiceNow Partner"
//               />
//             </div>

//             <div className="feature-content">
//               <h4>ServiceNow Training</h4>
//               <div className="feature-arrow">→</div>
//             </div>
//           </a>

//           {/* <div className="feature-points">

//             <div className="feature-point">
//               <span>✓</span>
//               <p>Get Trained in ServiceNow</p>
//             </div>

//             <div className="feature-point">
//               <span>✓</span>
//               <p>Get Certified by ServiceNow</p>
//             </div>

//             <div className="feature-point">
//               <span>✓</span>
//               <p>Online or Classroom Training</p>
//             </div>

//             <div className="feature-point">
//               <span>✓</span>
//               <p>ServiceNow Admin | Developer | BA | AI Specialist</p>
//             </div>

//             <div className="feature-point">
//               <span>✓</span>
//               <p>Fees ($$) and Terms Apply</p>
//             </div>

//             <div className="feature-point">
//               <span>✓</span>
//               <p>Win full-time or Contract Jobs</p>
//             </div>

//             <div className="feature-point">
//               <span>✓</span>
//               <p>Gain Practical Experience</p>
//             </div>

//           </div> */}

//           {/* Drupal */}
//           <div className="whats-new-feature">
//             <div className="feature-icon drupal-feature-icon">
//               <img
//                 src={drupalLogo}
//                 alt="Drupal"
//               />
//             </div>

//             <div className="feature-content">
//               <h4>Build Websites with Drupal CMS</h4>
//               {/* <div className="feature-arrow">→</div> */}
//             </div>
//           </div>

//           {/* Partner Logos */}
//           <div className="whats-new-partners">

//             <img
//               src={drupalLogo}
//               alt="Drupal"
//               className="whats-drupal-logo"
//             />

//             <span className="partner-divider"></span>

//             <div className="acquia-partner-logo">
//               <img
//                 src={acquiaLogo}
//                 alt="Acquia Partner"
//               />
//               <span>PARTNER</span>
//             </div>

//           </div>

//         </div>


//         {/* RIGHT FLYER */}
//         <div className="whats-new-right">

//           <div className="whats-new-flyer">

//             <img
//               src={snconfirmation}
//               alt="Tiara ServiceNow Training and Drupal CMS"
//               className="whats-new-flyer-image"
//             />

//           </div>

//         </div>

//       </div>
//     </>
//   );
//   break;

case 'WhatIsNew':
  renderContent = () => (
    <div className="spotlights-section">

      {/* =====================================================
          HEADING
          ===================================================== */}
      <div className="spotlights-heading-wrap">
        <h3 className="spotlights-heading">
          Our Spotlights
        </h3>
        {/* <a className='register-btn' href='/boothvisitor'>Register for IT Basics Training</a> */}
      </div>

{/* =====================================================
    TOP CONTENT
    ===================================================== */}
{/* =====================================================
    THREE CARDS - SAME ROW
    ===================================================== */}
<div className="spotlights-grid">

  {/* ===================================================
      1. SERVICE NOW TRAINING
      =================================================== */}
  <div className="spotlight-card spotlight-training">

    <div className="spotlight-card-header">

      <div className="spotlight-logo spotlight-servicenow-logo">
        <img
          src={servicenowpartner}
          alt="ServiceNow Partner"
        />
      </div>

      <div className="spotlight-header-content">
        <h4><img src={servicenowmain} style={{width:"10rem"}}/>  Training</h4>
        {/* <span>Professional Training</span> */}
      </div>

    </div>

    <div className="spotlight-points">

      <div className="spotlight-point">
        <span>✓</span>
        <p>Get Trained in ServiceNow</p>
      </div>

      <div className="spotlight-point">
        <span>✓</span>
        <p>Get Certified by ServiceNow</p>
      </div>

      <div className="spotlight-point">
        <span>✓</span>
        <p>Online or Classroom Training</p>
      </div>

      <div className="spotlight-point">
        <span>✓</span>
        <p>Fees ($$) and Terms Apply</p>
      </div>

      <div className="spotlight-point">
        <span>✓</span>
        <p>Gain Practical Experience</p>
      </div>

     

      <div className="spotlight-point">
        <span>✓</span>
        <p>Win full-time or Contract Jobs</p>
      </div>
 <div className="spotlight-point">
        <span>✓</span>
        <p>
          ServiceNow Admin | Developer | BA | AI Specialist
        </p>
      </div>
    </div>

    <div className="spotlight-action">
      <a
        href="/snconfirmation"
        className="spotlight-btn spotlight-apply-btn"
      >
        Register
        <span>→</span>
      </a>
    </div>

  </div>


  {/* ===================================================
      2. OUR OFFERINGS
      =================================================== */}
  <div className="offerings-card">

    <h4 className="offerings-heading">
      Our Offerings
    </h4>

    <div className="offerings-image-wrapper">

      <img
        src={offeringsImage}
        alt="Our Offerings - CRM, ERP, Web and Mobile Applications"
        className="offerings-image"
      />

    </div>

  </div>


  {/* ===================================================
      3. WE ARE HIRING
      =================================================== */}
  <div className="hiring-card">

    <div className="hiring-header">
      <h4>We Are Hiring</h4>
    </div>
    <div style={{display:"flex"}}>

   <div className="hiring-list">
  <div><span className="hiring-check">✓</span> ServiceNow Developers</div>
  <div><span className="hiring-check">✓</span> Drupal Developers</div>
  <div><span className="hiring-check">✓</span> React Developers</div>
  <div><span className="hiring-check">✓</span> Java Developers</div>
  <div><span className="hiring-check">✓</span> Business Analysts</div>
  <div><span className="hiring-check">✓</span> AI Engineers</div>
</div>
 <div className="hiring-image-wrapper">
    <img
      src={hiringImage}
      alt="We Are Hiring - Join Our Growing Team"
      className="hiring-image"
    />
  </div>
</div>
    <a
      href="/apply4job"
      className="spotlight-btn spotlight-apply-btn"
    >
      Apply
      <span>→</span>
    </a>

  </div>

</div>


{/* =====================================================
    WE ARE HIRING - FULL WIDTH BELOW
    ===================================================== */}
{/* <div className="hiring-card hiring-card-bottom">

  <div className="hiring-header">
    <h4>We Are Hiring</h4>
  </div>

  <div className="hiring-list">

    <div>✓ ServiceNow Developers</div>
    <div>✓ Drupal Developers</div>
    <div>✓ React Developers</div>
    <div>✓ Java Developers</div>
    <div>✓ Business Analysts</div>
    <div>✓ AI Engineers</div>

  </div>

  <a
    href="/careers"
    className="spotlight-btn spotlight-apply-btn"
  >
    Apply
    <span>→</span>
  </a>

</div> */}


    

    </div>
  );

  break;

    // case 'ServiceCRM':
    //   renderContent = () => (
    //     <div className="sevice-col-flex">
    //       {/* <div className="service-box"> */}
    //       <div className="box-heading service-bg" style={{
    //         border: "2px solid",
    //         borderImage: "linear-gradient(to right, rgb(167 153 183), rgb(162 196 255)) 1 / 1 / 0 stretch",
    //         borderRadius: "10px"
    //       }}>
    //         <img src={servicenow} alt="ServiceNow logo" className="service-icon" />
    //         <small className="">Consulting & Implementation Partner | Build Partner</small>
    //       </div>
    //       {/* </div> */}
    //       {/* <div className="flex-row-center1">
    //         <div className="parabanner ai-solutions-list mt-0 listitems-crmservice crm-width" style={{
    //           width: "100%",
    //           display: "grid",
    //           gridTemplateColumns: "repeat(4, 1fr)",
    //           gap: "10px"
    //         }}>
    //           {item.para.split(',').map((text, idx) => (
    //             <div className="bannerli2" key={idx}>
    //               <span className="banner-content w-nowrap">{text.trim()}</span>
    //             </div>
    //           ))}
    //         </div>
    //       </div> */}
    //       {/* <div className="flex-row-center1">
    //         <div className="parabanner ai-solutions-list mt-0 listitems-crmservice crm-width" style={{
    //           width: "100%",
    //           display: "grid",
    //           gridTemplateColumns: "repeat(2, 1fr)",
    //           gap: "10px"
    //         }}>
    //           {item.para.split(',').map((text, idx) => (
    //             <div className="bannerli2" key={idx}>
    //               <span className="banner-content" style={{ whiteSpace: "normal" }}>{text.trim()}</span>
    //             </div>
    //           ))}
    //         </div>
    //       </div> */}
    //                 <div className="flex-row-center1">
    //         <div className="parabanner ai-solutions-list mt-0 listitems-crmservice crm-width" style={{
    //           width: "100%",
    //           display: "grid",
    //           gridTemplateColumns: "repeat(2, 1fr)",
    //           gap: "10px"
    //         }}>
    //           {item.para.split(',').map((text, idx) => (
    //             <div className="bannerli2" key={idx}>
    //               <span className="banner-content" style={{ whiteSpace: "normal" }}>{text.trim()}</span>
    //             </div>
    //           ))}
    //         </div>
    //       </div>



    //       {/* <div className="servicebox" style={{ padding: "0px 58px" }}>
    //         <div className="banner-hightlight service-bg"><b>AI Agents</b></div>
    //         <div className="banner-hightlight service-bg"><b>Agentic AI workflows</b></div>
    //         <div className="banner-hightlight banner-highlight-img service-bg">
    //           <img src={servicenowpartner} alt="ServiceNow" />
    //         </div>
    //       </div> */}
    //       <div className="servicebox" style={{
    //         padding: "0px 58px",
    //         display: "flex",
    //         alignItems: "stretch",
    //         justifyContent: "center",
    //         gap: "20px"
    //       }}>
    //         <div className="banner-hightlight service-bg" style={{ display: "flex", justifyContent: "center", alignItems: "center", margin: 0, width: "260px", maxWidth: "none", padding: "10px 20px", whiteSpace: "nowrap" }}><b>AI Agents</b></div>
    //         <div className="banner-hightlight service-bg" style={{ display: "flex", justifyContent: "center", alignItems: "center", margin: 0, width: "260px", maxWidth: "none", padding: "10px 20px", whiteSpace: "nowrap" }}><b>Agentic AI workflows</b></div>
    //         <div className="banner-hightlight banner-highlight-img service-bg" style={{ display: "flex", justifyContent: "center", alignItems: "center", margin: 0, width: "260px", maxWidth: "none", padding: "10px 20px" }}>
    //           <img src={servicenowpartner} alt="ServiceNow" style={{ maxHeight: "100%", width: "auto" }} />
    //         </div>
    //       </div>


    //     </div>
    //   );
    //   break;
    case 'ServiceCRM':
      renderContent = () => (
        <div className=" sevice-col-flex">
          <h2 className="content-heading">Service CRM</h2>

          {/* <div className="service-box"> */}
          <div className="box-heading service-bg" style={{

            borderImage: "linear-gradient(to right, rgb(167 153 183), rgb(162 196 255)) 1 / 1 / 0 stretch",
            borderRadius: "10px", color: "#000"
          }}>
            <img src={servicenow} alt="ServiceNow logo" className="service-icon" />
            <small className='servicenowtext'>Consulting & Implementation Partner | Build Partner</small>
          </div>

          <div className="flex-row-center1">
            <div className="parabanner ai-solutions-list mt-0 listitems-crmservice crm-width">
              {item.para?.split(',').map((text, idx) => {
                const trimmedText = text.trim();
                const highlightItems = [
                  "IT Asset Mgmt (ITAM)",
                  "Public Sector (PSDS)",
                  "AI Experiences (Now Assist)",
                  "Security Ops (SecOps)"
                ];
                const isHighlight = highlightItems.includes(trimmedText);

                return (
                  <div className={`bannerli2 fw-bold ${isHighlight ? "highlight-textbg" : ""}`} key={idx} style={{ backgroundColor: isHighlight ? "#000!important" : "#155ab6!important" }}>
                    <span
                      className={`banner-content text-nowrap ${isHighlight ? "highlight-text" : ""
                        }`}
                      style={{
                        whiteSpace: "nowrap",
                        fontWeight: "bold",
                        fontSize: "17px", color: isHighlight ? "#000 !important" : "#155ab6 !important",
                      }}
                    >
                      {trimmedText}
                    </span>
                  </div>
                );
              })}
            </div>
          </div>

          {/* <div className="servicebox" style={{ padding: "0px 58px" }}>
            <div className="banner-hightlight service-bg"><b>AI Agents</b></div>
            <div className="banner-hightlight service-bg"><b>Agentic AI workflows</b></div>
            <div className="banner-hightlight banner-highlight-img service-bg">
              <img src={servicenowpartner} alt="ServiceNow" />
            </div>
          </div> */}
          <div className="servicebox" >
            <div className="banner-hightlight service-bg"><b>AI Agents</b></div>
            <div className="banner-hightlight service-bg"><b>Agentic AI workflows</b></div>
            <div className="banner-hightlight banner-highlight-img service-bg">
              <img src={servicenowpartner} alt="ServiceNow" className="servicenowimg" />
            </div>
          </div>


        </div>
      );
      break;


    //      case 'TiaraOverview':
    //       renderContent = () => (
    //            <>    

    //    <div className="overview-slide-container content-heading ">
    //       <h1 className="overview-title">Tiara Overview</h1>
    //       <FullViewFlyer flyerImage={flyer} />
    //     </div>
    // </>



    //        );
    //       break;
    case 'SalesCRM':
      renderContent = () => (
        <>
          <h2 className="content-heading">Sales CRM</h2>
          <div className="crm-content-area">


            {item.para.split(',').map((text, idx) => {
              const trimmedText = text.trim();
              return (

                <div key={idx} className="bannercard ">
                  <div className="para-partner">
                    <img
                      src={salesCRMIcons[trimmedText]}
                      alt={trimmedText}
                      className="banner-img"
                    />
                  </div>
                </div>
              );
            })}
          </div>
        </>
      );
      break;

    case 'ERP':
      renderContent = () => (
        <>
          {/* <ul className="parabanner ai-solutions-list bannerboxul erp-container" style={{ margin: "20px" }}>
            {item.para.split(',').map((text, idx) => {
              const trimmedText = text.trim();
              return (
                <li key={idx} className="bannercard">
                  <div className="para-partner">
                    <img src={erpIcons[trimmedText]} alt={trimmedText} className="banner-img" />
                  </div>
                </li>
              );
            })}
          </ul> */}


          {/* <div className="banner-subcontent">
            <div className="box-header">
              ERP Functions
            </div>
            <div className="banner-hightlight">
              GL, AR, AP, Order-to-Cash, Procure-to-Pay, HR <br />
              Inventory, Advanced Financials
            </div>
          </div> */}
          <ul className="parabanner ai-solutions-list bannerboxul erp-container" style={{ margin: "20px" }}>
            {item.para.split(',').map((text, idx) => {
              const trimmedText = text.trim();
              return (
                <li key={idx} className="bannercard">
                  <div className="para-partner">
                    <img src={erpIcons[trimmedText]} alt={trimmedText} className="banner-img" />
                  </div>
                </li>
              );
            })}
          </ul>

          <div className="banner-subcontent">
            <div className="box-header">
              ERP Functions
            </div>
            <div className="banner-hightlight">
              GL, AR, AP, Order-to-Cash, Procure-to-Pay, HR,
              Inventory, Advanced Financials
            </div>
          </div>

        </>
      );
      break;

    case 'Cloud':
      renderContent = () => {
        const cloudProviders = item.para.split(',').map(text => text.trim());

        const providerLabels = {
          AWS: { label: "Amazon", sub: "AWS" },
          Azure: { label: "MS Azure", sub: "Azure" },
          GCP: { label: "Google Cloud", sub: "GCP" },
        };

        return (
          <div className="cloud-section">
            <div className="cloud-cards-container">
              {cloudProviders.map((provider, idx) => {
                const config = providerLabels[provider] || { label: provider };

                return (
                  <div key={idx} className="cloud-card">
                    <div className="cloud-icon-wrapper">
                      <img
                        src={cloudIcons[provider]?.icon || cloudIcons[provider]}
                        alt={provider}
                        className="cloud-icon"
                      />
                    </div>

                    {/* Label */}
                    <h3 className="cloud-card-title" >
                      {config.label}
                    </h3>



                    <p className="cloud-card-description">
                      {cloudIcons[provider]?.description ||
                        'Enterprise-grade cloud platform for modern business needs'}
                    </p>
                  </div>
                );
              })}
            </div>
          </div>
        );
      };
      break;

    case 'AI':
      renderContent = () => (
        <>
          {/* Heading */}
          <div className="mt-0 llms-txt content-heading">LLMs</div>

          {/* AI Icons Grid */}
          {/* <div className="bannerboxtheme">
            <div className="row g-3">
              {item.para.split(',').map((text, idx) => {
                const trimmedText = text.trim();
                return (
                  <div key={idx} className="col-6">
                    <div
                      className="text-center"
                      style={{
                        padding: "15px",
                        borderRadius: "12px",
                        background: "#fff",
                        transition: "all 0.3s ease",
                        cursor: "pointer"
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = "translateY(-5px)";
                        e.currentTarget.style.boxShadow = "0 8px 20px rgba(0,0,0,0.4)";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "translateY(0)";
                        e.currentTarget.style.boxShadow = "none";
                      }}
                    >
                      <img
                        src={aiIcons[trimmedText]}
                        alt={trimmedText}
                        className="img-fluid"
                        style={{
                          maxWidth: "100px",
                          height: "auto"
                        }}
                      />
                    </div>
                  </div>
                );
              })}
            </div>
          </div> */}
          <div className="bannerboxtheme">
            <div className="row g-3">
              {item.para.split(',').map((text, idx) => {
                const trimmedText = text.trim();
                return (
                  <div key={idx} className="col-6">
                    <div
                      className="text-center"
                      style={{ padding: "15px", borderRadius: "12px", background: "#fff", transition: "all 0.3s ease", cursor: "pointer" }}
                      onMouseEnter={(e) => { e.currentTarget.style.transform = "translateY(-5px)"; /* ... */ }}
                      onMouseLeave={(e) => { e.currentTarget.style.transform = "translateY(0)"; /* ... */ }}>
                      <img src={aiIcons[trimmedText]} alt={trimmedText} className="img-fluid" style={{ maxWidth: "80px", height: "auto" }} />
                    </div>
                  </div>
                );
              })}
            </div>
          </div>


          {/* Text */}
          <p
            style={{
              color: "#fff",
              marginTop: "5px",
              fontSize: "16px", marginBottom: "0"
            }}
          >
            Build <b style={{ color: "#ffdf00" }}>Agentic AI</b> Solutions
          </p>

          {/* ElevenLabs Card */}
          <div
            className="d-flex align-items-center gap-3"
            style={{
              padding: "2px 20px",
              borderRadius: "12px",
              background: "#fff",
              border: "1px solid rgba(255,255,255,0.1)",
              transition: "all 0.3s ease",
              cursor: "pointer"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-3px)";
              e.currentTarget.style.boxShadow = "0 8px 25px rgba(0,0,0,0.4)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow = "none";
            }}
          >
            <img
              src={ElevenLabs}
              alt="Eleven Labs logo"
              className="img-fluid"
              style={{
                maxWidth: "100%",
                maxHeight: "50px",
                objectFit: "contain"
              }}
            />
            <div>
              <small
                style={{
                  color: "#000",
                  fontSize: "14px", lineHeight: "1.2rem",
                }}
              >
                Generative Voice AI solutions
              </small>
            </div>
          </div>
        </>
      );
      break;

    case 'DI':
      renderContent = () => {
        const rows = item.para.split(',').map(t => t.trim());

        return (
          <>

            {/* <h2 className='content-heading mb-2'>Data Engineering</h2> */}
            <ul className="parabanner ai-solutions-list bannerboxul di-container">

              <li className="bannercard di-card">
                <div className="para-partner di-content" >
                  <img src={item.src1} className="banner-img" />
                </div>
              </li>

              <li className="bannercard di-card">
                <div className="para-partner di-content">
                  <img src={item.src} className="banner-img" />
                </div>
              </li>
              <li className="bannercard di-card">
                <div className="para-partner di-content">
                  <img src={item.src2} className="banner-img" />
                </div>
              </li>
            </ul>

            <div className="di-subcontent" style={{ boxShadow: "none" }}>
              {rows.map((txt, idx) => {
                const url = "www.tiaraintegration.com";

                if (txt.includes(url)) {
                  const parts = txt.split(url);

                  return (
                    <div key={idx} className="banner-hightlight">
                      {parts[0]}
                      <a
                        href="https://www.tiaraintegration.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="custom-link"
                      >
                        &nbsp;{url}
                      </a>
                      {parts[1]}
                    </div>
                  );
                }

                return (
                  <div key={idx} className="banner-hightlight">
                    {txt}
                  </div>
                );
              })}
            </div>

          </>
        );
      };
      break;

    case 'Products':
      renderContent = () => {
        const products = item.para.split(',').map(text => text.trim());

        return (
          <div className="products-section">
            <div className="products-cards-container">
              {products.map((product, idx) => (
                <div key={idx} className="product-card">
                  <div className="product-icon-wrapper">
                    <img
                      src={productsIcons[product]?.icon || productsIcons[product]}
                      alt={product}
                      className={`product-icon ${productsIcons[product]?.className || ''}`}
                    />
                  </div>
                  <h3 className="product-card-title">{product}</h3>
                  <p className="product-card-description">
                    {productsIcons[product]?.description || 'Enterprise-grade product solution for modern business needs'}
                  </p>
                </div>
              ))}
            </div>
          </div>
        );
      };
      break;
    default:
      renderContent = () => (
        <p className="parabanner default-para">{item.para}</p>
      );
  }

  return {
    ...item,
    imageSrc: item.title === 'AI Solutions' ? aiBanner : item.src,
    titleClassName: [
      'content-heading',
      item.title.includes('ServiceNow Summit D.C.') ? 'special-title' : '',
      item.menuName === 'ServiceCRM' ? 'service-header-top' : '',
      item.menuName === 'ERP' ? 'erp-header-top' : '',
    ]
      .filter(Boolean)
      .join(' '),
    renderContent,
  };
});
